import { GlobalName } from "./global-name";
import { LocalStorageService } from "./local-stoarge-service";

export const AppRedirect: any = {

    redirectLogin() {
        const localService = new LocalStorageService();
        const user = localService.get(GlobalName.userName);
        const features = localService.get(GlobalName.features);
        const spaces = features?.spaces ?? [];

        // Si les données d'espace ne sont pas disponibles, on retombe sur le dashboard admin
        if (!user || !spaces.length) {
            return '/admin/dashboard';
        }

        switch (user.space) {
            case spaces[0]:
                return '/admin/dashboard';
            case spaces[1]:
                return '/professor-panel/accueil';
            default:
                return '/admin/dashboard';
        }
    }
};
